export default __webpack_public_path__ + "static/media/rocks-07.7c38c870.png";